import * as React from 'react';
import { Pagination } from '@mui/material';
import { PaginationContainer } from '../style';

interface RequestsPaginationProps {
  totalPages: number;
  currentPage: number;
  isLoading: boolean;
  onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
}

export default function RequestsPagination({
  totalPages,
  currentPage,
  isLoading,
  onPageChange
}: RequestsPaginationProps) {
  return (
    <PaginationContainer>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={onPageChange}
        color="primary"
        showFirstButton
        showLastButton
        disabled={isLoading}
      />
    </PaginationContainer>
  );
}
